function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBenefits = function SvgBenefits(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "miscellaneous/benefits"
  }, /*#__PURE__*/React.createElement("path", {
    id: "stroke",
    d: "M22.78 9.8C22.9243 10.5108 23 11.2466 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 0.999999 18.0751 1 12C1 5.92487 5.92487 0.999999 12 1C12.7534 1 15.5 1 17.5 2.5M22.5 3.64296L11.1429 15L7 10.7903",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
SvgBenefits.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SvgBenefits"
};
export default SvgBenefits;